import type {Page, Result} from 'framework';
import type {WeightSeriesRange} from '../application/ports/weight-tracking.repository';
import type {DeleteWeightEntry} from '../application/use-cases/delete-weight-entry';
import type {GetLatestWeight} from '../application/use-cases/get-latest-weight';
import type {GetWeightSeries} from '../application/use-cases/get-weight-series';
import type {ListWeightEntries} from '../application/use-cases/list-weight-entries';
import type {RecordWeight} from '../application/use-cases/record-weight';
import type {UpdateWeightEntry} from '../application/use-cases/update-weight-entry';
import type {WeightTrackingError} from '../domain/errors';
import type {WeightEntry, WeightEntryId} from '../domain/weight-entry';

export class WeightTrackingController {
  constructor(
    private readonly recordWeight: RecordWeight,
    private readonly updateWeightEntry: UpdateWeightEntry,
    private readonly deleteWeightEntry: DeleteWeightEntry,
    private readonly getLatestWeight: GetLatestWeight,
    private readonly listWeightEntries: ListWeightEntries,
    private readonly getWeightSeries: GetWeightSeries,
  ) {}

  record(weightKg: number): Promise<Result<WeightEntry, WeightTrackingError>> {
    return this.recordWeight.execute({weightKg});
  }

  updateEntry(
    weightEntryId: WeightEntryId,
    weightKg: number,
  ): Promise<Result<WeightEntry, WeightTrackingError>> {
    return this.updateWeightEntry.execute({weightEntryId, weightKg});
  }

  deleteEntry(weightEntryId: WeightEntryId): Promise<Result<void, WeightTrackingError>> {
    return this.deleteWeightEntry.execute({weightEntryId});
  }

  getLatest(): Promise<Result<WeightEntry | null, WeightTrackingError>> {
    return this.getLatestWeight.execute();
  }

  list(cursor: string | null): Promise<Result<Page<WeightEntry>, WeightTrackingError>> {
    return this.listWeightEntries.execute({cursor});
  }

  series(range: WeightSeriesRange): Promise<Result<readonly WeightEntry[], WeightTrackingError>> {
    return this.getWeightSeries.execute(range);
  }
}
